"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _routes = _interopRequireDefault(require("./modules/secrets/routes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MySecretsRoutes = function MySecretsRoutes(_ref) {
  var match = _ref.match,
      source = _ref.source,
      history = _ref.history;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: match.url,
    render: function render() {
      return /*#__PURE__*/_react.default.createElement(_routes.default, {
        source: source,
        match: match,
        history: history
      });
    }
  }));
};

MySecretsRoutes.propTypes = {
  history: _propTypes.default.any,
  match: _propTypes.default.any,
  source: _propTypes.default.string
};
var _default = MySecretsRoutes;
exports.default = _default;